import React from 'react'

const BreadCrumIcon = () => {
    return (
        <svg
            style={{ width: '100%' }}
            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.74963 22.1958L16.9453 12.0001L6.74963 1.80444" stroke="#7E8DA4" stroke-width="2.91305" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

export default BreadCrumIcon